import { Button, Col, Container, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import { black, light, solarGradient } from '../../theme/colors';

import DeleteAccountBlock from '../../ui/DeleteAccountBlock';
import EditProfileForm from '../../ui/EditProfileForm';
import FaqAndSupportBlock from '../../ui/FaqAndSupportBlock';
import Icon from '../../ui/Icon';
import SmartMeterDetails from '../../ui/SmartMeterDetails';
import { SolarPanelLarge } from '../../ui/Styled';
import WelcomeModal from '../../ui/Modal/WelcomeModal';
import { contentfulPropTypes } from '../../propTypes';
import { getCurrentUserInfo } from '../../utils/auth';
import smoothScroll from '../../utils/smoothScroll';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { usePersistedState } from '../../hooks';
import withContentfulTag from '../../utils/withContentfulTag';

const StyledSolarButton = styled(Button)`
  color: ${black};
  border-radius: 35px;
  text-align: left;
  background: ${solarGradient};
  border: none;
  padding-left: 20px;
  padding-right: 20px;
  cursor: pointer;

  &:hover {
    color: ${black};
  }
  &:active {
    color: ${black};
  }

  svg {
    max-width: 38px;
  }
`;

const OverviewContainer = ({ contentful, loading, fetched }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const initialState = {
    attributes: {
      given_name: '',
      family_name: '',
      email: '',
    },
  };
  const [currentUser, setUser] = usePersistedState('currentUser', initialState);
  const [showWelcome, setShowWelcome] = useState(
    location.pathname === '/account/overview/welcome',
  );
  const [deleteError, setDeleteError] = usePersistedState(
    'deleteError',
    undefined,
  );

  const onHideWelcome = () => {
    setShowWelcome(false);
    navigate('/account/overview');
  };

  useEffect(() => {
    getCurrentUserInfo().then(res => {
      if (res) {
        setUser(res);
      }
    });
  }, [setUser]);

  return (
    <>
      {showWelcome && (
        <WelcomeModal
          showWelcome={showWelcome}
          onHideWelcome={onHideWelcome}
          navigate={navigate}
        />
      )}
      {!loading && fetched && (
        <>
          <Container className="d-block d-lg-none">
            <Row>
              <Col md={8}>
                <StyledSolarButton
                  onClick={() => smoothScroll('solar')}
                  className="w-100">
                  <span className="mr-3">
                    <Icon colour={light} icon="solar" />
                  </span>
                  <span>Install Solar Panels</span>
                </StyledSolarButton>
              </Col>
            </Row>
            <Row>
              <Col md={8}>
                <hr className="my-4" />
              </Col>
            </Row>
          </Container>
          <EditProfileForm
            currentUser={currentUser}
            setUser={setUser}
            contentful={contentful}
          />
          <Container>
            <Row>
              <Col md={8} lg={8}>
                <hr className="my-4" />
              </Col>
            </Row>
          </Container>
          <SmartMeterDetails currentUser={currentUser} />
          <Container>
            <Row>
              <Col md={8} lg={8}>
                <hr className="my-4" />
              </Col>
            </Row>
          </Container>
          <DeleteAccountBlock
            currentUser={currentUser}
            deleteError={deleteError}
            setDeleteError={setDeleteError}
          />
          <Container>
            <Row>
              <Col md={8} lg={8}>
                <hr className="my-4" />
              </Col>
            </Row>
          </Container>
          <FaqAndSupportBlock />
          <Container className="d-block d-lg-none" id="solar">
            <Row>
              <Col md={8} lg={8}>
                <hr className="my-4" />
              </Col>
            </Row>
            <Row>
              <Col md={12} lg={12}>
                <SolarPanelLarge />
              </Col>
            </Row>
          </Container>
        </>
      )}
    </>
  );
};

OverviewContainer.propTypes = {
  ...contentfulPropTypes,
};

export default withContentfulTag(OverviewContainer, 'web_app_overview_page');
